
import { defineComponent, defineAsyncComponent, watch } from 'vue';
import { Steps } from 'ant-design-vue';
import controllerModuleFn from './js/controllerModule';
import roleInfo from './roleInfo/index.vue';
import './css/index.styl';

// const roleInfo = defineAsyncComponent(
//   () => import('./roleInfo/index.vue'),
// );
const dialogueInfo = defineAsyncComponent(
  () => import('./dialogueInfo/index.vue'),
);
const articleInfo = defineAsyncComponent(
  () => import('./articleInfo/index.vue'),
);
const deduceSetting = defineAsyncComponent(
  () => import('./deduceSetting/index.vue'),
);
const riskAnalysis = defineAsyncComponent(
  () => import('./riskAnalysis/index.vue'),
);
const deduceAnalysis = defineAsyncComponent(
  () => import('./deduceAnalysis/index.vue'),
);
const taskList = defineAsyncComponent(() => import('./taskList/index.vue'));

const component = defineComponent({
  // name: 'scenario-construction',
  components: {
    roleInfo,
    dialogueInfo,
    articleInfo,
    deduceSetting,
    riskAnalysis,
    deduceAnalysis,
    taskList,
    aSteps: Steps,
    aStep: Steps.Step,
  },
  setup() {
    const controllerModule = controllerModuleFn();
    const { sceneConstructModule } = controllerModule;

    watch(
      () => controllerModule.firstStep.value,
      (val) => {
        console.log(val);
      },
    );

    return { controllerModule, sceneConstructModule };
  },
});

export default component;
